import { FC, useState } from 'react';

import './Lightswitch.scss';

export type Props = {
	value: boolean;
	onToggle: (newValue: boolean) => void;
	text: string | undefined;
};

export const Lightswitch:  FC<Props> = ({value, onToggle, text}) => {

	const handleToggle = () => {
		onToggle(!value);
	};

	return(
		<div 
			className={`c-lightswitch ${value ? 'c-lightswitch--on' : 'c-lightswitch--off'}`} 
			onClick={() => handleToggle()}
		>
			<div className='c-lightswitch__switch-wrapper'>
				<div className='blobby'></div>
			</div>
			{
				text ? <div className='c-lightswitch__text'>{text}</div> : ''
			}
		</div>	
	);
};

